export var Theme;
(function (Theme) {
    Theme["Light"] = "Light";
    Theme["Dark"] = "Dark";
})(Theme || (Theme = {}));
const LightTheme = {
    ChamptionshipHeader: {
        color: '#2D2D2D',
        backgroundColor: '#E0E5EB'
    },
};
const DarkTheme = {
    ChamptionshipHeader: {
        color: '#FFFFFF',
        backgroundColor: '#2f2f2f'
    },
};
export const ThemeStyles = {
    [Theme.Dark]: DarkTheme,
    [Theme.Light]: LightTheme
};



// WEBPACK FOOTER //
// ./src/web-frontend-components/theming/theme.js